import React from 'react';
import { X, MessageCircle, Users } from 'lucide-react';
import Button from '../ui/Button';
import { LoadingSpinner } from '../ui/Loading';

const NonParticipantsModal = ({ isOpen, onClose, nonParticipants, loading }) => {
  const handleWhatsAppClick = (phone) => {
    if (phone) {
      const whatsappUrl = `https://wa.me/${phone.replace(/\D/g, '')}`;
      window.open(whatsappUrl, '_blank');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto border border-purple-500/20">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-purple-600 to-pink-600 p-6 rounded-t-2xl z-10">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-2xl font-bold text-white flex items-center gap-2">
                <Users className="w-7 h-7" />
                Não Participantes
              </h2>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:text-purple-200 transition-colors"
            >
              <X size={28} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {loading ? (
            <div className="flex justify-center items-center py-12">
              <LoadingSpinner size="lg" />
            </div>
          ) : nonParticipants.length === 0 ? (
            <div className="text-center py-12">
              <MessageCircle className="w-16 h-16 text-gray-500 mx-auto mb-4" />
              <p className="text-gray-400 text-lg mb-2">Nenhum não participante encontrado</p>
              <p className="text-gray-500 text-sm">Todos os usuários elegíveis já participaram do evento.</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left">
                <thead className="text-xs text-gray-400 uppercase bg-slate-900/50">
                  <tr>
                    <th scope="col" className="px-6 py-3">Nome</th>
                    <th scope="col" className="px-6 py-3">Personagem</th>
                    <th scope="col" className="px-6 py-3">Level</th>
                    <th scope="col" className="px-6 py-3">Contato</th>
                  </tr>
                </thead>
                <tbody>
                  {nonParticipants.map((participant, index) => (
                    <tr key={index} className="border-b border-white/10 hover:bg-slate-800/30">
                      <td className="px-6 py-4 font-medium text-white">
                        {participant.userName}
                      </td>
                      <td className="px-6 py-4 text-gray-300">
                        {participant.characterName}
                      </td>
                      <td className="px-6 py-4 text-gray-300">
                        {participant.level}
                      </td>
                      <td className="px-6 py-4">
                        {participant.phone ? (
                          <Button
                            size="sm"
                            onClick={() => handleWhatsAppClick(participant.phone)}
                            className="bg-green-600 hover:bg-green-700 text-white"
                          >
                            <MessageCircle className="w-4 h-4 mr-2" />
                            WhatsApp
                          </Button>
                        ) : (
                          <span className="text-gray-500">Não informado</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-slate-900 p-6 border-t border-white/10 rounded-b-2xl flex justify-end">
          <Button
            variant="outline"
            onClick={onClose}
          >
            Fechar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NonParticipantsModal;
